import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Accordion.css';

const AccordionBody = ({ className = '', active = false, children = '', ...otherProps }) => {

  const classes = classNames(
    'ng-ui-accordion-body',
    className,
    {
      'ng-hidden': !active,
    },
  );

  return (
    <div
      className={classes}
      {...otherProps}
      aria-hidden={!active}
    >
      { children }
    </div>
  );
};

AccordionBody.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  active: PropTypes.bool,
};

AccordionBody.displayName = 'Accordion.AccordionBody';

export default AccordionBody;